import Echo from "laravel-echo";
import Pusher from "pusher-js";

export function initBroadcasting() {
    window.Pusher = Pusher;
    window.Echo = new Echo({
        broadcaster: "reverb",
        key: window.appConfig.reverb.key,
        wsHost: window.appConfig.reverb.host,
        wsPort: window.appConfig.reverb.port ?? 80,
        wssPort: window.appConfig.reverb.port ?? 443,
        forceTLS: (window.appConfig.reverb.scheme ?? "https") === "https",
        enabledTransports: ["ws", "wss"],
    });
}
